import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import EventBus from '@/store/EventBus'

export default function useRestoreDraft() {
  const restoring = ref(false)

  async function restoreDraft(id) {
    restoring.value = true
    try {
      await draftApi.restore(id)
      return true
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null
        ? data.message
        : 'A server error occurred. Please try again later.'
      EventBus.$emit('http-error', msg)
      return false
    } finally {
      restoring.value = false
    }
  }

  return { restoreDraft, restoring }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useRestoreDraft.js